export const requestFields = [
  {
    key: "id",
    label: "№",
    //stickyColumn: true,
    //thClass:"bg-grey bg-lighten-2",
  },
  {
    key: "date",
    label: "Дата",
    formatter: (value) => { return new Date(value).toLocaleDateString() },
  },
  {
    key: "description",
    label: "Назначение платежа",
    formatter: (value, key, item) => { return item.body.products.map(p => `${p.name}${p.quantity && p.units ? ', ' : ''}${p.quantity || ''}${p.units || ''}`).join(", "); },
  },
  {
    key: "status",
    label: "Статус",
    formatter: (value, key, item) => {
      if (item.status === 'done') {
        return 'Выполнена';
      } else if (item.body && item.body.products && item.body.products.find(p => { return p.type === "card_fuel" || p.type === "card_money" || p.type === "ticket_fuel" })) {
        return item.bill_id ? item.waybill_id ? 'Выполнена' : 'Обрабатывается' : 'Принята';
      } else {
        return item.bill_id ? item.waybill_id && item.invoice_id ? 'Выполнена' : 'Обрабатывается' : 'Принята';
      }
    },
  },
  {
    key: "bill_number",
    label: "№ Счёта",
  },
  {
    key: "waybill_number",
    label: "№ Накладной",
  },
  {
    key: "invoice_number",
    label: "№ Счёта-фактуры",
  },
];

export const billFields = [
  {
    key: "id",
    label: "№ Счёта",
  },
  {
    key: "date",
    label: "Дата",
  },
  {
    key: "description",
    label: "	Наименование товаров (работ, услуг)",
  },
  {
    key: "status",
    label: "Статус",
  },
  {
    key: "sum",
    label: "Сумма",
  },
];

export const waybillFields = [
  {
    key: "id",
    label: "№ Накладной",
  },
  {
    key: "date",
    label: "Дата",
  },
  {
    key: "description",
    label: "	Наименование товаров (работ, услуг)",
  },
  {
    key: "sum",
    label: "Сумма",
  },
];

export const invoiceFields = [
  {
    key: "id",
    label: "№ Счёта-фактуры",
  },
  {
    key: "date",
    label: "Дата",
  },
  {
    key: "description",
    label: "	Наименование товаров (работ, услуг)",
  },
  {
    key: "sum",
    label: "Сумма",
  },
];